/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum StipulatorAliases {
  APPLICATION_BAR_0 = 'application-bar-0',
  AVATAR_USER = 'avatar-user',
  CONTEXT_MENU_0 = 'context-menu-0',
  DROP_DOWN_MENSAGEM = 'drop-down-mensagem',
  DROP_DOWN_PROFILES = 'drop-down-profiles',
  DROP_DOWN_USUARIO = 'drop-down-usuario',
  FOOTER_0 = 'footer-0',
  FRAGMENT_0 = 'fragment-0',
  FRAGMENT_MENSAGENS = 'fragment-mensagens',
  HPMS_CONTRATOS_OPTIONS = 'hpms-contratos-options',
  IMAGE_0 = 'image-0',
  LAYOUT_MENSAGENS = 'layout-mensagens',
  LAYOUT_PROFILES = 'layout-profiles',
  LAYOUT_STIPULATOR = 'layout-stipulator',
  LINK_MENSAGEM = 'link-mensagem',
  LINK_MOSTRAR_TODAS_MENSAGENS = 'link-mostrar-todas-mensagens',
  OPTION_DADOS_GRUPO_CONTRATUAL = 'option-dados-grupo-contratual',
  OPTION_EXIT = 'option-exit',
  OPTION_MENSAGEM = 'option-mensagem',
  OPTION_MEUS_DADOS = 'option-meus-dados',
  PANEL_0 = 'panel-0',
  PANEL_1 = 'panel-1',
  PANEL_3 = 'panel-3',
  PANEL_CONTEXT_MENU_CONTRATOS = 'panel-context-menu-contratos',
  PANEL_CONTRATOS = 'panel-contratos',
  PANEL_DROPDOWN_PROFILE = 'panel-dropdown-profile',
  PANEL_MENSAGENS = 'panel-mensagens',
  PANEL_MOSTRAR_TODAS_MENSAGENS = 'panel-mostrar-todas-mensagens',
  PANEL_PROFILES = 'panel-profiles',
  PANEL_SUBESTIPULANTE = 'panel-subestipulante',
  PANEL_TEXT_PROFILE = 'panel-text-profile',
  REPEATER_CONTRATOS = 'repeater-contratos',
  TEXT_1 = 'text-1',
  TEXT_325956 = 'text-325956',
  TEXT_629370 = 'text-629370',
  TEXT_CD_ESTIPULANTE = 'text-cd-estipulante',
  TEXT_DS_ESTIPULANTE = 'text-ds-estipulante',
  TEXT_LABEL_ESTIPULANTE = 'text-label-estipulante',
  TEXT_NM_SUBESTIPULANTE = 'text-nm-subestipulante',
  TEXT_NR_CONTRATO = 'text-nr-contrato',
  TEXT_PROFILE = 'text-profile',
}
export { StipulatorAliases };
